import AuthWrapper from 'modules/Auth/AuthWrapper'
import Reducer from 'modules/Auth/reducer'
import Sagas from 'modules/Auth/saga'

export default AuthWrapper

export { Sagas as Sagas, Reducer as Reducer }
